/* Persona collection grid — in-place filters and mobile expansion.
   02 · States & Logic B1 + F. No page loads, no scroll jumps. */
(() => {
  const FADE = 160;
  const desktop = window.matchMedia('(min-width: 990px)');

  class CollectionGrid {
    constructor(root) {
      this.root = root;
      this.list = root.querySelector('[data-ps-cgrid-list]');
      this.items = [...root.querySelectorAll('.ps-cgrid__item')];
      this.chips = [...root.querySelectorAll('[data-filter]')];
      this.count = root.querySelector('[data-ps-count]');
      this.more = root.querySelector('[data-ps-more]');
      this.guide = root.querySelector('[data-ps-guide]');
      this.initial = parseInt(root.dataset.initial, 10) || 4;
      this.state = { cat: '', finish: '' };

      const params = new URLSearchParams(location.search);
      if (this.hasChip('cat', params.get('category'))) this.state.cat = params.get('category');
      if (this.hasChip('finish', params.get('finish'))) this.state.finish = params.get('finish');
      if (this.state.cat || this.state.finish) this.list.dataset.collapsed = 'false';

      this.chips.forEach((chip) => chip.addEventListener('click', () => this.onChip(chip)));
      this.more?.addEventListener('click', () => this.toggleMore());
      root.querySelector('[data-ps-sort]')?.addEventListener('change', (e) => {
        const url = new URL(location.href);
        url.searchParams.set('sort_by', e.target.value);
        location.assign(url.toString() + '#collection');
      });
      desktop.addEventListener('change', () => this.render(false));
      this.render(false);
    }

    hasChip(type, value) {
      return !!value && this.chips.some((c) => c.dataset.filter === type && c.dataset.value === value);
    }

    matches(item, cat, finish) {
      return (!cat || item.dataset.cat === cat) && (!finish || item.dataset.finish === finish);
    }

    onChip(chip) {
      if (chip.disabled) return;
      const { filter, value } = chip.dataset;
      if (filter === 'cat') this.state.cat = value;
      // finish is a toggle: pressing the active finish clears it
      else this.state.finish = this.state.finish === value ? '' : value;
      // a filtered result is never hidden behind the expand button
      if (this.state.cat || this.state.finish) this.list.dataset.collapsed = 'false';
      this.syncUrl();
      this.render(true);
    }

    syncUrl() {
      const url = new URL(location.href);
      this.state.cat ? url.searchParams.set('category', this.state.cat) : url.searchParams.delete('category');
      this.state.finish ? url.searchParams.set('finish', this.state.finish) : url.searchParams.delete('finish');
      history.replaceState(history.state, '', url);
    }

    render(animate) {
      const apply = () => {
        const { cat, finish } = this.state;
        let shown = 0;
        this.items.forEach((item) => {
          const on = this.matches(item, cat, finish);
          item.hidden = !on;
          if (on) shown += 1;
          item.classList.toggle('is-over', on && shown > this.initial);
        });
        this.count.textContent = shown;
        this.count.nextSibling && (this.count.nextSibling.textContent = shown === 1 ? ' product' : ' products');

        this.chips.forEach((chip) => {
          const { filter, value } = chip.dataset;
          const pressed = filter === 'cat' ? this.state.cat === value : this.state.finish === value;
          chip.setAttribute('aria-pressed', pressed);
          // disable a chip whose combination would return nothing
          const c = filter === 'cat' ? value : cat;
          const f = filter === 'finish' ? value : finish;
          chip.disabled = !pressed && !this.items.some((i) => this.matches(i, c, f));
        });

        if (this.more) {
          const expandable = shown > this.initial;
          this.more.parentElement.hidden = !expandable;
          const open = this.list.dataset.collapsed === 'false';
          this.more.setAttribute('aria-expanded', open);
          this.more.querySelector('[data-ps-more-label]').textContent = open ? this.more.dataset.less : this.more.dataset.more;
        }

        if (this.guide) {
          // read the live column count: 4, 2 on mobile, 2 for the two-plate layout
          const cols = getComputedStyle(this.list).gridTemplateColumns.split(' ').length || 1;
          const visible = desktop.matches || this.list.dataset.collapsed === 'false' ? shown : Math.min(shown, this.initial);
          this.guide.hidden = visible % cols === 0;
        }
      };

      if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return apply();
      this.list.classList.add('is-fading');
      setTimeout(() => {
        apply();
        this.list.classList.remove('is-fading');
      }, FADE);
    }

    toggleMore() {
      const open = this.list.dataset.collapsed !== 'false';
      const before = [...this.list.querySelectorAll('.ps-cgrid__item.is-over:not([hidden])')];
      this.list.dataset.collapsed = open ? 'false' : 'true';
      if (open) {
        before.forEach((el) => {
          el.classList.remove('is-in');
          void el.offsetWidth;
          el.classList.add('is-in');
        });
      }
      this.render(false);
      if (!open) this.root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  const boot = () => document.querySelectorAll('[data-ps-cgrid]').forEach((el) => {
    if (!el.psGrid) el.psGrid = new CollectionGrid(el);
  });
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
